import http from '../plugins/axios';

export default {

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/all'
        });
    }
}